<script setup lang="ts">
import { useRouter } from 'vue-router';

import ThemedButton from '@/components/base/ThemedButton.vue';

const router = useRouter();
const handleGoToAutoDeliveryProducts = () => {
  router.push('/autodelivery-bestsellers/');
};
</script>

<template>
  <div class="flex items-center justify-center my-12 flex-column">
    <div class="flex items-center justify-center md:flex-row flex-column">
      <img
        class="h-6 md:h-7 lg:h-10"
        src="@/assets/auto-delivery/logo.svg"
        alt="Auto Delivery Logo"
      />
      <h2
        class="mt-2 text-3xl md:pl-3 md:my-6 lg:text-4xl md:text-2xl lg:pb-2 md:pb-1 font-sofia-pro"
      >
        How It Works
      </h2>
    </div>
    <!-- Desktop/Tablets -->
    <img
      class="hidden-xs"
      src="@/assets/auto-delivery/steps-horizontal.png"
      alt="Horizontal Steps on Auto Delivery"
    />
    <!-- Mobile -->
    <img
      class="hidden-md hidden-lg hidden-sm"
      src="@/assets/auto-delivery/steps-horizontal-mobile.png"
      alt="Horizontal Steps on Auto Delivery"
    />
    <ThemedButton class="mt-8 h-11" @click="handleGoToAutoDeliveryProducts" theme="gray">
      Start Shopping with Auto-Delivery
    </ThemedButton>
  </div>
</template>
